import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  formControlContainer: {
    paddingBottom: '10px',
    marginLeft: '0px',
    marginRight: '0px',
    borderBottom: '1px solid rgba(44, 45, 62, 0.3)',

    '& .MuiInput-underline:before': {
      border: 'unset',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      border: 'none',
    },
  },
  attachmentContainer: {
    display: 'inline-flex',
    fontFamily: 'Roboto',
    fontSize: '0.9em',
    alignItems: 'center',
    margin: '5px',
    maxWidth: '700px',
  },
  attachmentsContainer: {
    margin: '5px',
    display: 'flex',
    flexDirection: 'column',
    borderTop: '1px solid rgba(44, 45, 62, 0.3)',
  },
  subjectInput: {
    '& input': {
      paddingTop: '25px',
      paddingLeft: '5px'
    },
  },
  replyRecipient: {
    fontSize: '14px',
  },
  root: {},
}));
